import React from 'react';
import Styles from './calendar-styles.scss';
const Calendar = ({ date, className }) => {
    return (React.createElement("time", { className: [Styles.calendarWrap, className].join(' ') },
        React.createElement("span", { "data-testid": "day", className: Styles.day }, date.getDate().toString().padStart(2, '0')),
        React.createElement("span", { "data-testid": "month", className: Styles.month }, date.toLocaleString('pt-BR', { month: 'short' }).replace('.', '')),
        React.createElement("span", { "data-testid": "year", className: Styles.year }, date.getFullYear())));
};
export default Calendar;
